import React from 'react';
import DependencySelect from 'react-select';
import { components } from 'react-select';
import ChevronDown from 'static/icons/arrow_down.svg';
import SvgIconButton from 'shared/buttons/SvgIconButton';
import { ButtonColor } from 'shared/buttons/models/ButtonModels';

export type SelectItem = { label: string; value: string; disabled?: boolean; index?: number };

export const customSelectColors = {
  grey: '#F7F8F8',
  white: '#FFFFFF'
};

type CustomSelectProps = {
  label: string;
  options: SelectItem[];
  onChange: (selected: SelectItem | null) => void;
  styles: Record<string, unknown>;
  containerClasses?: string;
  labelClasses?: string;
  backgroundColor?: string;
  isDisabled?: boolean;
  isOptionDisabled?: (option: SelectItem) => boolean;
  value?: SelectItem;
};

export default function CustomSelect(props: CustomSelectProps) {
  const { label } = props;
  const value = props.value ?? props.options[0];

  const SingleValue = ({ selectProps, data }: { selectProps: any; data: any }) => {
    return (
      <>
        <div className="flex justify-between flex-wrap items-center w-full gap-1 py-1">
          {props.label && <div className={`${props.labelClasses} font-bold`}>{label}</div>}
          <div className="font-bold text-ev-dark-purple truncate max-w-[225px]">{selectProps.getOptionLabel(data)}</div>
        </div>
      </>
    );
  };

  const DropdownIndicator = (props: any) => {
    if (props.isDisabled) {
      return (
        <components.DropdownIndicator {...props}>
          <i className="fas fa-lock" />
        </components.DropdownIndicator>
      );
    }
    return (
      <components.DropdownIndicator {...props}>
        <SvgIconButton
          Icon={ChevronDown}
          width={14}
          height={9}
          buttonColor={ButtonColor.Transparent}
          onClick={() => null}
        />
      </components.DropdownIndicator>
    );
  };
  return (
    <div className={`relative ${props.containerClasses}`}>
      <DependencySelect
        className="label-select-container"
        classNamePrefix="everviz-select"
        components={{ SingleValue, DropdownIndicator }}
        isSearchable={false}
        value={value}
        menuPlacement="auto"
        {...props}
      />
    </div>
  );
}
